<template>
  <div class='mainContent'>
    <van-collapse v-model="activeNames" accordion>
      <van-collapse-item v-for="(item,index) in faqList" :key="index" size="large" :name="index">{{item.answer}}
        <template #title>
          <div><van-icon name="question" /> {{item.question}}</div>
        </template>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script type="text/ecmascript-6">
import Vue from 'vue';
import {Collapse, CollapseItem, Icon } from 'vant';

Vue.use(Collapse).use(CollapseItem).use(Icon);

export default {
  name: "applyClaim",
  data() {
    return {
      activeNames: 0,
      faqList: [
        {
          question: '挂科时间多久申请补偿？',
          answer: '挂科后尽快申请补偿，保司补偿标准为挂一科补偿一科，单科发起时间不得超过30个自然日，超过30个自然日，视为放弃挂科，保司不做赔付。'
        }, {
          question: '发起补偿申请后补偿款多久到账？',
          answer: '当您提交申请成功后，会审核您提交的订单，审核通过后会进行打款。您可关注牛保网点击“补偿查询”查看当前审核进度。'
        }, {
          question: '补偿款上面显示非本人收款，我找谁要补偿款？',
          answer: '补偿款统一补偿到驾校指定账户，如您查到补偿进度显示已打款，您可咨询驾校/教练。'
        }, {
          question: '补偿申请对预约考试有影响吗？',
          answer: '您在公众号提起“学员补偿”后就可以正常预考，保险与您的学车预约考试没有直接关系。'
        }, {
          question: '补偿申请时输入错误了怎么办？',
          answer: '未正确填写补偿申请将会被驳回，驳回后可以重新发起补偿。'
        }, {
          question: '我提交的补偿订单显示“驳回”状态怎么办？',
          answer: '显示“驳回”表示您提交的订单审核失败，需要重新发起补偿申请（发起补偿时请按照驳回备注检查所提交资料是否正确）。'
        }, {
          question: '拿证后如何提交补偿申请？',
          answer: '拿证后不能正常提交补偿，需要联系牛保工作人员协助处理补偿。'
        }, {
          question: '在补偿时扫描二维码显示“补偿申请失败”怎么处理？',
          answer: '补偿时生成的二维码为“动态二维码”，“动态二维码”在3分钟内未能成功扫码则会显示“补偿申请失败”，所以需在3分钟内用交管12123APP扫码。'
        }, {
          question: '成功扫码12123APP后，显示进度条不动出现卡死状态？',
          answer: '请检查网络问题，在良好的网络下重新申请补偿。'
        }, {
          question: '学员自己怎么投保？',
          answer: '本产品目前不支持学员自行在线投保，需要投保的学员请联系驾校进行投保。'
        }
      ],
    };
  },
  components: {},
  mounted() {
    document.title = '常见问题';
  },
  methods: {},
  watch: {},
};
</script>

<style lang="scss">
$them: #067adc;
* {
  margin: 0;
  padding: 0;
}

.mainContent {
  overflow: hidden;
  background: #ededed;
  min-height: 100%;
  .van-icon{
    color: #1989fa;
    font-size: 18px;
    vertical-align: middle;
  }
}

</style>



// WEBPACK FOOTER //
// FAQ.vue?05cd9ac2